import { createContext, useContext } from 'react';
import { IDataTableContext } from '@Types/DataTableComponentProps';

type TValue = IDataTableContext;
export const DataTableContext = createContext<TValue>({} as TValue);
export const useDataTableProviderContext = () => {
  return useContext(DataTableContext);
};
